var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"appRef",attrs:{"id":"index"}},[_c('div',{staticClass:"bg"},[(_vm.loading)?_c('dv-loading',[_vm._v("Loading...")]):_c('div',{staticClass:"host-body"},[_c('big-header')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }